export const data = [
  {
    id: 1,
    title: '',
    paragraphs: [
      {
        id: 1,
        text: 'Our primary focus is on customer satisfaction. In the event that you are displeased with our meal kits, we will review your feedback and refund the money where appropriate. Our Policy for the cancellation and refund will be as follows:',
      },
    ],
  },
  {
    id: 2,
    title: 'Refund Policy',
    paragraphs: [
      {
        id: 1,
        text: "We will try our best to satisfy our customers and we provide a 'First Order Guarantee'. In case you are not satisfied with our products in your first order, please write to us at hello@thecuminclub.com with your feedback and concerns, and we will process a refund where appropriate after review. If paid by credit card, refunds will be issued to the original credit card provided at the time of purchase and in case of payment gateway name payments refund will be made to the same account.",
      },
    ],
  },
  {
    id: 3,
    title: 'Managing Your Subscription',
    paragraphs: [
      {
        id: 1,
        text: 'Did you know you can skip any of your five upcoming orders? To skip, sign in to your account and skip the necessary orders in the Upcoming Orders Section. Additionally, you are also able to cancel/deactivate your meal plan from the subscriptions section of your account - this will ensure that no future orders are executed.',
      },
    ],
  },
  {
    id: 4,
    title: 'Cancellation Policy',
    paragraphs: [
      {
        id: 1,
        text: "For all subscription orders, we provide a 2-day email notice reminding customers of their upcoming order. This email serves as a final opportunity to make changes before an order is processed and charged. Changes can be made through Account page on the website or by writing to hello@thecuminclub.com. We honor all cancellation requests that come in before the subscription order is placed. Once the order is placed and goes to 'Shipment processed' status we are unable to cancel the order.",
      },
    ],
  },
];
